import React, {useState, useEffect} from 'react';
import {useLocation, Link} from 'react-router-dom';
import { connect } from 'react-redux';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import { Container, Row, Col } from 'react-bootstrap';
import { likePost, savePost, unlikePost, unsavePost} from './redux/actions';
import JoinModal from './modals/JoinModal';
import LoginModal from './modals/LoginModal';
import { notification } from 'antd';
import { SmileOutlined, FrownOutlined } from '@ant-design/icons';
import userimage from './Images/user.png';
import Linkify from 'react-linkify';
import {FaHeart, FaBookmark, FaShareAlt} from 'react-icons/fa';
import Navigation from './Navigation';



const Search = ({allUsers, feedPosts, likePost, savePost, unlikePost, unsavePost}) => {
  const location = useLocation();
  const[users, setUsers] = useState([]);
  const[posts, setPosts] = useState([]);
  const[isLoggedIn, setIsLoggedIn] = useState(false);
  const[isCreatePostModalVisible, setIsCreatePostModalVisible] = useState(false);
  const [likedPosts, setLikedPosts] = useState([]);
  const[savedPosts, setSavedPosts] = useState([])

  const[isJoinModalVisible, setIsJoinModalVisible] = useState(false);
  const[isLoginModalVisible, setIsLoginModalVisible] = useState(false);

  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = (event) => {
    location.state = null
    const query = event.target.value;
    setSearchQuery(query); // Update the search query state

    const userMatches = allUsers.filter((user) =>
      Object.values(user).some((value) => String(value).includes(query))
    );

    // Search in allPosts for matching posts
    const postMatches = feedPosts.filter((post) =>
      Object.values(post).some((value) => String(value).includes(query))
    );

    // Set the userResults state
    setUsers(userMatches);

    // Set the postResults state
    setPosts(postMatches);
  };

  const [expandedPosts, setExpandedPosts] = useState([]);

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      if(!user){
        setIsLoggedIn(false)
      } else {
        setIsLoggedIn(true)
      }
    })

    const initialExpandedPosts = new Array(feedPosts.length).fill(false);
        setExpandedPosts(initialExpandedPosts);
        
        firebase.firestore()
        .collection('likes')
        .get()
        .then((querySnapshot) => {
            const likedPostsArray = [];
            querySnapshot.forEach((doc) => {
                //console.log(doc.id, doc.data())
                likedPostsArray.push(doc.id);
            })
            setLikedPosts(likedPostsArray);
        })
        firebase.firestore()
        .collection('saves')
        .get()
        .then((querySnapshot) => {
            const savedPostsArray = [];
            querySnapshot.forEach((doc) => {
                //console.log(doc.id, doc.data())
                savedPostsArray.push(doc.id);
            })
            setSavedPosts(savedPostsArray);
        })

        if (location.state && location.state.text) { // Check for location.state before accessing its properties
            const userMatches = allUsers.filter((user) =>
              Object.values(user).some((value) => String(value).includes(location.state.text))
            );
        
            // Search in allPosts for matching posts
            const postMatches = feedPosts.filter((post) =>
              Object.values(post).some((value) => String(value).includes(location.state.text))
            );
        
            // Set the userResults state
            setUsers(userMatches);
        
            // Set the postResults state
            setPosts(postMatches);
        }
  }, [allUsers,feedPosts, location.state]);

  useEffect(() => {
    if (!location.state && searchQuery === '') {
        setUsers([])
        setPosts([])
    }
  },[searchQuery, location.state])

  const togglePostExpand = (index) => {
    setExpandedPosts((prevExpandedPosts) => {
    const newExpandedPosts = [...prevExpandedPosts];
    newExpandedPosts[index] = !newExpandedPosts[index];
    return newExpandedPosts;
    });
  };

  const onLikePress = (posterId, postId, innerArray) => {
    if(isLoggedIn) {
        const userId = firebase.auth().currentUser.uid;
        const likeRef = firebase.firestore()
        .collection('likes')
        .doc(`${userId}_${postId}`);

        likeRef.get()
        .then((doc) => {
            if (doc.exists) {
                //console.log('User has liked the post.');
                unlikePost(innerArray)
                firebase.firestore()
                .collection('likes') // Replace with the name of your collection
                .doc(`${userId}_${postId}`)
                .delete()
                .then(() => {
                    console.log('Document successfully deleted.');
                })
                .catch((error) => {
                    console.error('Error deleting document:', error);
                });
                firebase.firestore()
                    .collection('posts')
                    .doc(posterId)
                    .collection('userPosts')
                    .doc(postId)
                    .get()
                    .then((snapshot) => {
                        const likes = snapshot.data().likes - 1
                        firebase.firestore()
                        .collection('posts')
                        .doc(posterId)
                        .collection('userPosts')
                        .doc(postId)
                        .update({
                            likes: likes
                        })
                        .then(() => {
                            console.log('Updated successful');
                        }).catch((error) => {
                            console.log(error)
                        })
                    })
                    .catch((error) => { 
                        console.log('Error getting post:', error);
                    });
            } else {
                //console.log('User has not liked the post.');
                likePost(innerArray)
                const userId = firebase.auth().currentUser.uid;
                const likeRef = firebase.firestore()
                .collection('likes')
                .doc(`${userId}_${postId}`);

                likeRef.set({
                userId,
                postId: postId,
                timestamp: firebase.firestore.FieldValue.serverTimestamp()
                })
                .then(() => {
                    console.log('Like added successfully.');
                    firebase.firestore()
                    .collection('posts')
                    .doc(posterId)
                    .collection('userPosts')
                    .doc(postId)
                    .get()
                    .then((snapshot) => {
                        const likes = snapshot.data().likes + 1
                        firebase.firestore()
                        .collection('posts')
                        .doc(posterId)
                        .collection('userPosts')
                        .doc(postId)
                        .update({
                            likes: likes
                        })
                        .then(() => {
                            console.log('Updated successful');
                        }).catch((error) => {
                            console.log(error)
                        })
                    })
                    .catch((error) => { 
                        console.log('Error getting post:', error);
                    });
                })
                .catch((error) => {
                    console.error('Error adding like:', error);
                });
            }
        })
        .catch((error) => {
            console.error('Error retrieving like:', error);
        });
    } else {
        setIsJoinModalVisible(true);
    }
}
const onSavePress = (posterId, postId, innerArray) => {
    if(isLoggedIn) {
        const userId = firebase.auth().currentUser.uid;
        const saveRef = firebase.firestore()
        .collection('saves')
        .doc(`${userId}_${postId}`);

        saveRef.get()
        .then((doc) => {
            if (doc.exists) {
                //console.log('User has saved the post.');
                unsavePost(innerArray)
                firebase.firestore()
                .collection('saves') // Replace with the name of your collection
                .doc(`${userId}_${postId}`)
                .delete()
                .then(() => {
                    console.log('Document successfully deleted.');
                })
                .catch((error) => {
                    console.error('Error deleting document:', error);
                });
                firebase.firestore()
                    .collection('posts')
                    .doc(posterId)
                    .collection('userPosts')
                    .doc(postId)
                    .get()
                    .then((snapshot) => {
                        const saves = snapshot.data().saves - 1
                        firebase.firestore()
                        .collection('posts')
                        .doc(posterId)
                        .collection('userPosts')
                        .doc(postId)
                        .update({
                            saves: saves
                        })
                        .then(() => {
                            console.log('Updated successful');
                        }).catch((error) => {
                            console.log(error)
                        })
                    })
                    .catch((error) => { 
                        console.log('Error getting post:', error);
                    });
            } else {
                //console.log('User has not saved the post.');
                savePost(innerArray)
                const userId = firebase.auth().currentUser.uid;
                const saveRef = firebase.firestore()
                .collection('saves')
                .doc(`${userId}_${postId}`);

                saveRef.set({
                userId,
                postId: postId,
                timestamp: firebase.firestore.FieldValue.serverTimestamp()
                })
                .then(() => {
                    //console.log('Save added successfully.');
                    firebase.firestore()
                    .collection('posts')
                    .doc(posterId)
                    .collection('userPosts')
                    .doc(postId)
                    .get()
                    .then((snapshot) => {
                        const saves = snapshot.data().saves + 1
                        firebase.firestore()
                        .collection('posts')
                        .doc(posterId)
                        .collection('userPosts')
                        .doc(postId)
                        .update({
                            saves: saves
                        })
                        .then(() => {
                            console.log('Updated successful');
                        }).catch((error) => {
                            console.log(error)
                        })
                    })
                    .catch((error) => { 
                        console.log('Error getting post:', error);
                    });
                })
                .catch((error) => {
                    console.error('Error adding save:', error);
                });
            }
        })
        .catch((error) => {
            console.error('Error retrieving save:', error);
        });
    } else {
        setIsJoinModalVisible(true)
    }
}

const openSuccessNotification = (message) => {
  notification.open({
    message: `${message}`,
    duration: 2,
    icon: <SmileOutlined style={{ color: '#71b324' }} />,
  });
};

const openErrorNotification = (message, error) => {
  notification.open({
    message: `${message}`,
    description: `${error}`,
    duration: 11,
    icon: <FrownOutlined style={{ color: 'red' }} />

  });
};


const onSharePress = (postId, posterId) => {
  const url = `https://cuisn.web.app/post?creator=${posterId}&id=${postId}`
  const handleShare = async () => {
      if (navigator.share) {
          navigator.share({
              title: 'Cuisn',
              text: 'Check out this awesome food post!',
              url: url,
          })
          .then(() => console.log('Successfully shared'))
          .catch((error) => openErrorNotification('Error sharing', error));
      } else {
          navigator.clipboard.writeText(url)
          .then(() => {
              openSuccessNotification('URL copied to clipboard')
          })
          .catch((error) => {
              openErrorNotification('Error copying to clipboard', error)
          });
      }
  };
  handleShare()          
}

  function calculateTimePassed(givenTime) {
    var currentTime = new Date();
    var timeDiff = currentTime - givenTime;
  
    // Define the time units and their respective values in milliseconds
    var timeUnits = [
      { unit: 'second', value: 1000 },
      { unit: 'minute', value: 1000 * 60 },
      { unit: 'hour', value: 1000 * 60 * 60 },
      { unit: 'day', value: 1000 * 60 * 60 * 24 },
      { unit: 'month', value: 1000 * 60 * 60 * 24 * 30.44 },
      { unit: 'year', value: 1000 * 60 * 60 * 24 * 365.25 }
    ];
  
    // Iterate through time units and return the time passed in the largest unit possible
    for (var i = 0; i < timeUnits.length; i++) {
      if (timeDiff < timeUnits[i].value) {
        var timePassed = Math.floor(timeDiff / timeUnits[i - 1].value);
        var unit = timeUnits[i - 1].unit;
        return `${timePassed} ${unit}${timePassed !== 1 ? 's' : ''} ago`;
      }
    }
}

  return (
    <div>
        <Container fluid>
            <Row>
                <Col xs={12} sm={12} md={12} lg={8}>
                    <div className='search-input-div'>
                        <input placeholder='Search' className='search-input' value={searchQuery} onChange={handleSearchChange}></input>
                    </div>

                    {users.length > 0 ? (
                        <div className='search-users-div'>
                            {users.map((element, key) => {
                                if (element.hasOwnProperty('name') && element.name !== '') {
                                    return (
                                        <div key={key} className='search-user-div'>
                                            <Link to={`/profile?id=${element.userId}`} className='link-to-profile'>
                                                <Row>
                                                    <Col xs={3} sm={3} md={3} lg={3} className='search-image-col'>
                                                        <div className='search-image-div'>
                                                        {element.hasOwnProperty('image') && element.image !== '' ? (
                                                            <img src={element.image} alt='User' className='search-user-image' />
                                                        ) : (
                                                            <img src={userimage} alt='User' className='search-user-image' />
                                                        )}
                                                        </div>
                                                    </Col>
                                                    <Col xs={9} sm={9} md={9} lg={9}>
                                                        <div className='search-names-div'>
                                                        <p className='search-name'>{element.name}</p>
                                                        <p className='search-username'>{element.username}</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </div>
                                    );
                                }
                            return null;
                            })}
                        </div>
                    ) : null}

                    {(posts.length > 0) ? 
                        <div className='search-posts-div'>
                            {posts.map((innerArray, index) => {
                                if(innerArray.posterRole === 'chef' || innerArray.posterRole === 'restaurant' || innerArray.posterRole === 'food-blogger' || innerArray.posterRole === 'food-content-creator' || innerArray.posterRole === 'food-items-vendor') {
                                    if (innerArray.postTitle && innerArray.postMessage && !innerArray.postURL) {
                                            let liked = false;
                                            let saved = false;

                                            if (isLoggedIn && firebase.auth().currentUser) {
                                                const userId = firebase.auth().currentUser.uid;
                                                liked = likedPosts.includes(`${userId}_${innerArray.postId}`);
                                                saved = savedPosts.includes(`${userId}_${innerArray.postId}`);
                                                // ...
                                            }

                                            const timePassed = calculateTimePassed(new Date(innerArray.timePosted));

                                            return (
                                                <div className='feed-card-div' key={index}>
                                                    <div className='feed-card-upper-div'>
                                                        {(isLoggedIn && firebase.auth().currentUser) ? (innerArray.posterId === firebase.auth().currentUser.uid) ? 
                                                            <Link to={`/profile`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span> 
                                                            </Link> :
                                                            <Link to={`/profile?id=${innerArray.posterId}`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span>
                                                            </Link> :
                                                            <Link to={`/profile?id=${innerArray.posterId}`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span>
                                                            </Link>
                                                        }
                                                        <span className='feed-span-time'>{timePassed}</span>
                                                        {/* <FaEllipsisH className='feed-menu'/> */}
                                                    </div>
                                                    <div className="feed-card-post-body-div text-post-div">
                                                        <h6>{innerArray.postTitle}</h6>
                                                        {innerArray.postMessage.length > 100 && !expandedPosts[index] ? (
                                                            <>
                                                                <Linkify>
                                                                    <p>{innerArray.postMessage.slice(0, 100)}...<button
                                                                        className="read-more-button"
                                                                        onClick={() => togglePostExpand(index)}
                                                                    >
                                                                        Read More
                                                                    </button>
                                                                    </p>
                                                                </Linkify>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Linkify>
                                                                    <p>{innerArray.postMessage} 
                                                                        {innerArray.postMessage.length > 100 && (
                                                                            <button
                                                                            className="read-less-button"
                                                                            onClick={() => togglePostExpand(index)}
                                                                            >
                                                                            Read Less
                                                                            </button>
                                                                        )}
                                                                    </p>
                                                                </Linkify>
                                                            </>
                                                        )}
                                                    </div>
                                                    <div className='feed-card-lower-div'>
                                                        <Row className='feed-row'>
                                                            <Col xs={12} md={12} lg={12}>
                                                                <Row>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-like">
                                                                        <button className='like-span-button' onClick={() => onLikePress(innerArray.posterId, innerArray.postId, innerArray)}>{liked ? <FaHeart className='comment-icon active-icon'></FaHeart> : <FaHeart className='comment-icon inactive-icon'></FaHeart>}</button>
                                                                        <span className='like-number'>{innerArray.likes}</span>
                                                                    </Col>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-comment">
                                                                        <button className="comment-span-button" onClick={() => onSavePress(innerArray.posterId, innerArray.postId, innerArray)}>{saved ? <FaBookmark className='comment-icon active-bookmark-icon'/> : <FaBookmark className='comment-icon inactive-icon'/>}</button>
                                                                        <span className='comment-number'>{innerArray.saves}</span>
                                                                    </Col>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-share">
                                                                        <button className="comment-span-button" onClick={() => onSharePress(innerArray.postId, innerArray.posterId)}><FaShareAlt className='comment-icon'/></button>
                                                                    </Col>
                                                                </Row>   
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            )
                                        } else if (!innerArray.postTitle && innerArray.postMessage && !innerArray.postURL) {
                                            let liked = false;
                                            let saved = false;

                                            if (isLoggedIn && firebase.auth().currentUser) {
                                            const userId = firebase.auth().currentUser.uid;
                                            liked = likedPosts.includes(`${userId}_${innerArray.postId}`);
                                            saved = savedPosts.includes(`${userId}_${innerArray.postId}`);
                                            // ...
                                            }

                                            const timePassed = calculateTimePassed(new Date(innerArray.timePosted));

                                            //console.log('Has message but no title and image');
                                            return (
                                                <div className='feed-card-div' key={index}>
                                                    <div className='feed-card-upper-div'>
                                                        {(isLoggedIn && firebase.auth().currentUser) ? (innerArray.posterId === firebase.auth().currentUser.uid) ? 
                                                            <Link to={`/profile`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span> 
                                                            </Link> :
                                                            <Link to={`/profile?id=${innerArray.posterId}`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span>
                                                            </Link> :
                                                            <Link to={`/profile?id=${innerArray.posterId}`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span>
                                                            </Link>
                                                        }
                                                        <span className='feed-span-time'>{timePassed}</span>
                                                        {/* <FaEllipsisH className='feed-menu'/> */}
                                                    </div>
                                                    <div className="feed-card-post-body-div text-post-div">
                                                        {innerArray.postMessage.length > 100 && !expandedPosts[index] ? (
                                                            <>
                                                                <Linkify>
                                                                    <p>{innerArray.postMessage.slice(0, 100)}...<button
                                                                        className="read-more-button"
                                                                        onClick={() => togglePostExpand(index)}
                                                                    >
                                                                        Read More
                                                                    </button>
                                                                    </p>
                                                                </Linkify>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Linkify>
                                                                    <p>{innerArray.postMessage} 
                                                                        {innerArray.postMessage.length > 100 && (
                                                                            <button
                                                                            className="read-less-button"
                                                                            onClick={() => togglePostExpand(index)}
                                                                            >
                                                                            Read Less
                                                                            </button>
                                                                        )}
                                                                    </p>
                                                                </Linkify>
                                                            </>
                                                        )}
                                                    </div>
                                                    <div className='feed-card-lower-div'>
                                                        <Row className='feed-row'>
                                                            <Col xs={12} md={12} lg={12}>
                                                                <Row>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-like">
                                                                        <button className='like-span-button' onClick={() => onLikePress(innerArray.posterId, innerArray.postId, innerArray)}>{liked ? <FaHeart className='comment-icon active-icon'></FaHeart> : <FaHeart className='comment-icon inactive-icon'></FaHeart>}</button>
                                                                        <span className='like-number'>{innerArray.likes}</span>
                                                                    </Col>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-comment">
                                                                        <button className="comment-span-button" onClick={() => onSavePress(innerArray.posterId, innerArray.postId, innerArray)}>{saved ? <FaBookmark className='comment-icon active-bookmark-icon'/> : <FaBookmark className='comment-icon inactive-icon'/>}</button>
                                                                        <span className='comment-number'>{innerArray.saves}</span>
                                                                    </Col>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-share">
                                                                        <button className="comment-span-button" onClick={() => onSharePress(innerArray.postId, innerArray.posterId)}><FaShareAlt className='comment-icon'/></button>
                                                                    </Col>
                                                                </Row>   
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            )
                                        } else if (innerArray.postTitle && innerArray.postMessage && innerArray.postURL) {
                                            let liked = false;
                                            let saved = false;

                                            if (isLoggedIn && firebase.auth().currentUser) {
                                            const userId = firebase.auth().currentUser.uid;
                                            liked = likedPosts.includes(`${userId}_${innerArray.postId}`);
                                            saved = savedPosts.includes(`${userId}_${innerArray.postId}`);
                                            // ...
                                            }

                                            const timePassed = calculateTimePassed(new Date(innerArray.timePosted));

                                            //console.log('Has message and title and image');
                                            return (
                                                <div className='feed-card-div' key={index}>
                                                    <div className='feed-card-upper-div'>
                                                        {(isLoggedIn && firebase.auth().currentUser) ? (innerArray.posterId === firebase.auth().currentUser.uid) ? 
                                                            <Link to={`/profile`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span> 
                                                            </Link> :
                                                            <Link to={`/profile?id=${innerArray.posterId}`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span>
                                                            </Link> :
                                                            <Link to={`/profile?id=${innerArray.posterId}`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span>
                                                            </Link>
                                                        }
                                                        <span className='feed-span-time'>{timePassed}</span>
                                                        {/* <FaEllipsisH className='feed-menu'/> */}
                                                    </div>
                                                    <div className="feed-card-post-body-div text-post-div">
                                                        <h6>{innerArray.postTitle}</h6>
                                                        {innerArray.postMessage.length > 100 && !expandedPosts[index] ? (
                                                            <>
                                                                <Linkify>
                                                                    <p>{innerArray.postMessage.slice(0, 100)}...<button
                                                                        className="read-more-button"
                                                                        onClick={() => togglePostExpand(index)}
                                                                    >
                                                                        Read More
                                                                    </button>
                                                                    </p>
                                                                </Linkify>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Linkify>
                                                                    <p>{innerArray.postMessage} 
                                                                        {innerArray.postMessage.length > 100 && (
                                                                            <button
                                                                            className="read-less-button"
                                                                            onClick={() => togglePostExpand(index)}
                                                                            >
                                                                            Read Less
                                                                            </button>
                                                                        )}
                                                                    </p>
                                                                </Linkify>
                                                            </>
                                                        )}
                                                    </div>
                                                    <div className='feed-card-post-body-div'>
                                                        <img src={innerArray.postURL} className="feed-card-image" alt="Feed" loading="lazy"></img>
                                                    </div>
                                                    <div className='feed-card-lower-div'>
                                                        <Row className='feed-row'>
                                                            <Col xs={12} md={12} lg={12}>
                                                                <Row>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-like">
                                                                        <button className='like-span-button' onClick={() => onLikePress(innerArray.posterId, innerArray.postId, innerArray)}>{liked ? <FaHeart className='comment-icon active-icon'></FaHeart> : <FaHeart className='comment-icon inactive-icon'></FaHeart>}</button>
                                                                        <span className='like-number'>{innerArray.likes}</span>
                                                                    </Col>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-comment">
                                                                        <button className="comment-span-button" onClick={() => onSavePress(innerArray.posterId, innerArray.postId, innerArray)}>{saved ? <FaBookmark className='comment-icon active-bookmark-icon'/> : <FaBookmark className='comment-icon inactive-icon'/>}</button>
                                                                        <span className='comment-number'>{innerArray.saves}</span>
                                                                    </Col>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-share">
                                                                        <button className="comment-span-button" onClick={() => onSharePress(innerArray.postId, innerArray.posterId)}><FaShareAlt className='comment-icon'/></button>
                                                                    </Col>
                                                                </Row>   
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            )
                                        } else if (!innerArray.postTitle && !innerArray.postMessage && innerArray.postURL) {
                                            let liked = false;
                                            let saved = false;

                                            if (isLoggedIn && firebase.auth().currentUser) {
                                            const userId = firebase.auth().currentUser.uid;
                                            liked = likedPosts.includes(`${userId}_${innerArray.postId}`);
                                            saved = savedPosts.includes(`${userId}_${innerArray.postId}`);
                                            // ...
                                            }
                                            const timePassed = calculateTimePassed(new Date(innerArray.timePosted));
                                            //console.log('Has image, but no message and title');
                                            return (
                                                <div className='feed-card-div' key={index}>
                                                    <div className='feed-card-upper-div'>
                                                        {(isLoggedIn && firebase.auth().currentUser) ? (innerArray.posterId === firebase.auth().currentUser.uid) ? 
                                                            <Link to={`/profile`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span> 
                                                            </Link> :
                                                            <Link to={`/profile?id=${innerArray.posterId}`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span>
                                                            </Link> :
                                                            <Link to={`/profile?id=${innerArray.posterId}`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span>
                                                            </Link>
                                                        }
                                                        <span className='feed-span-time'>{timePassed}</span>
                                                        {/* <FaEllipsisH className='feed-menu'/> */}
                                                    </div>
                                                    <div className='feed-card-post-body-div'>
                                                        <img src={innerArray.postURL} className="feed-card-image" alt="Feed" loading="lazy"></img>
                                                    </div>
                                                    <div className='feed-card-lower-div'>
                                                        <Row className='feed-row'>
                                                            <Col xs={12} md={12} lg={12}>
                                                                <Row>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-like">
                                                                        <button className='like-span-button' onClick={() => onLikePress(innerArray.posterId, innerArray.postId, innerArray)}>{liked ? <FaHeart className='comment-icon active-icon'></FaHeart> : <FaHeart className='comment-icon inactive-icon'></FaHeart>}</button>
                                                                        <span className='like-number'>{innerArray.likes}</span>
                                                                    </Col>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-comment">
                                                                        <button className="comment-span-button" onClick={() => onSavePress(innerArray.posterId, innerArray.postId, innerArray)}>{saved ? <FaBookmark className='comment-icon active-bookmark-icon'/> : <FaBookmark className='comment-icon inactive-icon'/>}</button>
                                                                        <span className='comment-number'>{innerArray.saves}</span>
                                                                    </Col>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-share">
                                                                        <button className="comment-span-button" onClick={() => onSharePress(innerArray.postId, innerArray.posterId)}><FaShareAlt className='comment-icon'/></button>
                                                                    </Col>
                                                                </Row>   
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            )
                                        } else if (innerArray.postTitle && !innerArray.postMessage && innerArray.postURL) {
                                            let liked = false;
                                            let saved = false;

                                            if (isLoggedIn && firebase.auth().currentUser) {
                                            const userId = firebase.auth().currentUser.uid;
                                            liked = likedPosts.includes(`${userId}_${innerArray.postId}`);
                                            saved = savedPosts.includes(`${userId}_${innerArray.postId}`);
                                            // ...
                                            }
                                            const timePassed = calculateTimePassed(new Date(innerArray.timePosted));

                                            //console.log('Has title and image, but no message');
                                            return (
                                                <div className='feed-card-div' key={index}>
                                                    <div className='feed-card-upper-div'>
                                                        {(isLoggedIn && firebase.auth().currentUser) ? (innerArray.posterId === firebase.auth().currentUser.uid) ? 
                                                            <Link to={`/profile`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span> 
                                                            </Link> :
                                                            <Link to={`/profile?id=${innerArray.posterId}`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span>
                                                            </Link> :
                                                            <Link to={`/profile?id=${innerArray.posterId}`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span>
                                                            </Link>
                                                        }
                                                        <span className='feed-span-time'>{timePassed}</span>
                                                        {/* <FaEllipsisH className='feed-menu'/> */}
                                                    </div>
                                                    <div className='feed-card-post-body-div text-post-div'>
                                                    <h6>{innerArray.postTitle}</h6>
                                                    </div>
                                                    <div className='feed-card-post-body-div'>
                                                        <img src={innerArray.postURL} className="feed-card-image" alt="Feed" loading="lazy"></img>
                                                    </div>
                                                    <div className='feed-card-lower-div'>
                                                        <Row className='feed-row'>
                                                            <Col xs={12} md={12} lg={12}>
                                                                <Row>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-like">
                                                                        <button className='like-span-button' onClick={() => onLikePress(innerArray.posterId, innerArray.postId, innerArray)}>{liked ? <FaHeart className='comment-icon active-icon'></FaHeart> : <FaHeart className='comment-icon inactive-icon'></FaHeart>}</button>
                                                                        <span className='like-number'>{innerArray.likes}</span>
                                                                    </Col>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-comment">
                                                                        <button className="comment-span-button" onClick={() => onSavePress(innerArray.posterId, innerArray.postId, innerArray)}>{saved ? <FaBookmark className='comment-icon active-bookmark-icon'/> : <FaBookmark className='comment-icon inactive-icon'/>}</button>
                                                                        <span className='comment-number'>{innerArray.saves}</span>
                                                                    </Col>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-share">
                                                                        <button className="comment-span-button" onClick={() => onSharePress(innerArray.postId, innerArray.posterId)}><FaShareAlt className='comment-icon'/></button>
                                                                    </Col>
                                                                </Row>   
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            )
                                        } else if (!innerArray.postTitle && innerArray.postMessage && innerArray.postURL) {
                                            let liked = false;
                                            let saved = false;

                                            if (isLoggedIn && firebase.auth().currentUser) {
                                            const userId = firebase.auth().currentUser.uid;
                                            liked = likedPosts.includes(`${userId}_${innerArray.postId}`);
                                            saved = savedPosts.includes(`${userId}_${innerArray.postId}`);
                                            // ...
                                            }
                                            const timePassed = calculateTimePassed(new Date(innerArray.timePosted));
                                            //console.log('Has message and image, but no title');
                                            return (
                                                <div className='feed-card-div' key={index}>
                                                    <div className='feed-card-upper-div'>
                                                        {(isLoggedIn && firebase.auth().currentUser) ? (innerArray.posterId === firebase.auth().currentUser.uid) ? 
                                                            <Link to={`/profile`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span> 
                                                            </Link> :
                                                            <Link to={`/profile?id=${innerArray.posterId}`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span>
                                                            </Link> :
                                                            <Link to={`/profile?id=${innerArray.posterId}`} className='link-to-profile'>
                                                                {(innerArray.posterImage === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={innerArray.posterImage} alt=''className='feed-card-user-image'></img>}
                                                                <span className='feed-span'>{innerArray.posterName} </span>
                                                            </Link>
                                                        }
                                                        <span className='feed-span-time'>{timePassed}</span>
                                                        {/* <FaEllipsisH className='feed-menu'/> */}
                                                    </div>
                                                    <div className="feed-card-post-body-div text-post-div">
                                                        {innerArray.postMessage.length > 100 && !expandedPosts[index] ? (
                                                            <>
                                                                <Linkify>
                                                                    <p>{innerArray.postMessage.slice(0, 100)}...<button
                                                                        className="read-more-button"
                                                                        onClick={() => togglePostExpand(index)}
                                                                    >
                                                                        Read More
                                                                    </button>
                                                                    </p>
                                                                </Linkify>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Linkify>
                                                                    <p>{innerArray.postMessage} 
                                                                        {innerArray.postMessage.length > 100 && (
                                                                            <button
                                                                            className="read-less-button"
                                                                            onClick={() => togglePostExpand(index)}
                                                                            >
                                                                            Read Less
                                                                            </button>
                                                                        )}
                                                                    </p>
                                                                </Linkify>
                                                            </>
                                                        )}
                                                    </div>
                                                    <div className='feed-card-post-body-div'>
                                                        <img src={innerArray.postURL} className="feed-card-image" alt="Feed" loading="lazy"></img>
                                                    </div>
                                                    <div className='feed-card-lower-div'>
                                                        <Row className='feed-row'>
                                                            <Col xs={12} md={12} lg={12}>
                                                                <Row>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-like">
                                                                        <button className='like-span-button' onClick={() => onLikePress(innerArray.posterId, innerArray.postId, innerArray)}>{liked ? <FaHeart className='comment-icon active-icon'></FaHeart> : <FaHeart className='comment-icon inactive-icon'></FaHeart>}</button>
                                                                        <span className='like-number'>{innerArray.likes}</span>
                                                                    </Col>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-comment">
                                                                        <button className="comment-span-button" onClick={() => onSavePress(innerArray.posterId, innerArray.postId, innerArray)}>{saved ? <FaBookmark className='comment-icon active-bookmark-icon'/> : <FaBookmark className='comment-icon inactive-icon'/>}</button>
                                                                        <span className='comment-number'>{innerArray.saves}</span>
                                                                    </Col>
                                                                    <Col xs={4} md={4} lg={4} className="icons-col-share">
                                                                        <button className="comment-span-button" onClick={() => onSharePress(innerArray.postId, innerArray.posterId)}><FaShareAlt className='comment-icon'/></button>
                                                                    </Col>
                                                                </Row>   
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            )
                                        } 
                                    }
                                return null;
                            })}
                        </div> : 
                        null
                    }
                </Col>
                <Col xs={0} sm={12} md={0} lg={4}>

                </Col>
            </Row>
        </Container>
        <Navigation setIsCreatePostModalVisible={setIsCreatePostModalVisible} isCreatePostModalVisible={isCreatePostModalVisible} isLoggedIn={isLoggedIn}></Navigation>
      <JoinModal isJoinModalVisible={isJoinModalVisible} setIsJoinModalVisible={setIsJoinModalVisible} setIsLoginModalVisible={setIsLoginModalVisible} isLoginModalVisible={isLoginModalVisible}/>
      <LoginModal isLoginModalVisible={isLoginModalVisible} setIsLoginModalVisible={setIsLoginModalVisible} setIsJoinModalVisible={setIsJoinModalVisible} isJoinModalVisible={isJoinModalVisible}/>
    </div>
  )
}

const mapStateToProps = (state) => {
  //console.log('State', state)
  return {
      allUsers: state.allUsers,
      feedPosts: state.feedPosts
  }
}
const mapDispatchToProps = (dispatch) => ({
  likePost: (post) => dispatch(likePost(post)),
  savePost: (post) => dispatch(savePost(post)),
  unlikePost: (post) => dispatch(unlikePost(post)),
  unsavePost: (post) => dispatch(unsavePost(post))
});


export default connect(mapStateToProps, mapDispatchToProps)(Search)